import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;
interface ICustomLabel {
    displayText?: string;
    subDisplayText?: string;
    value?: string;
}
const DisplayText = styled.span`
    text-align: center;
    ${setFontVariant("dataTable1", carbon[500])};
`;
const SubDisplayText = styled.span`
    text-align: center;
    ${setFontVariant("queryBar1", carbon[300])};
`;
const Value = styled.span`
    text-align: center;
    ${setFontVariant("dataTable2", carbon[500])};
`;

export const CustomLabel: FC<ICustomLabel> = (props) => {
    const { displayText, subDisplayText, value } = props;
    return (
        <FlexColumn
            gap={"4px"}
            justifyContent="center"
        >
            <DisplayText>{displayText}</DisplayText>
            {subDisplayText ? <SubDisplayText>{subDisplayText}</SubDisplayText> : null}
            {value ? <Value>{value}</Value> : null}
        </FlexColumn>
    );
};
